import { isDefined } from "@omni/utils/helper.utils";
import { RefObject, useEffect } from "react";

export const useOutsideAlerter = (
    fn: () => void,
    ref: RefObject<HTMLElement | null>,
    ignoredElementRefs: Array<RefObject<HTMLElement | null>> = []
) => {
    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        const handleClickOutside = (event: MouseEvent) => {
            const ignoredElements = ignoredElementRefs
                .map((ref) => ref.current)
                .filter(isDefined);

            const target = event.target as HTMLElement | undefined;
            if (!target) {
                return;
            }

            if (ignoredElements.includes(target)) {
                return;
            }

            if (
                target.parentElement &&
                ignoredElements.includes(target.parentElement)
            ) {
                return;
            }

            if (
                ref.current &&
                !ref.current.contains(target) &&
                typeof fn === "function"
            ) {
                fn();
            }
        };

        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
};
